"use client";

const Footer = () => {
  return (
    <footer className="py-1 pt-5">
      <p className="text-center mt-1">
        Book IT - 2019-2023, All Rights Reserved
      </p>
    </footer>
  );
};

export default Footer;
